import { Component } from "@angular/core";

@Component({
  selector: "app-cnet-enterprise-content",
  templateUrl: "cnet-enterprise-content.component.html",
})
export class CnetEnterpriseContentComponent {}
